import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from "./utils/translations/en";
import { pt } from "./utils/translations/pt";
import { it } from "./utils/translations/it";

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        lng: 'en',  // Define o idioma padrão como inglês
        fallbackLng: 'en',  // Caso o idioma não esteja disponível, usará inglês
        resources: {
            en: {
                translation: en
            },
            pt: {
                translation: pt
            },
            it: {
                translation: it
            }
        }
    });